import { IResponseProps } from '@/entities/Response'
import { IUserProps } from '@/entities/User'

export const Types = {
  store: 'store',
  current: 'current',
  filter: 'filter',
  scrollTop: 'scrollTop'
}

export const path = 'user/'

export class Store implements FluxStandardAction<IResponseProps<IUserProps>> {
  type = path + Types.store
  constructor(public payload: IResponseProps<IUserProps>) {}
}

export class Current implements FluxStandardAction<IUserProps | null> {
  type = path + Types.current
  constructor(public payload: IUserProps | null) {}
}

export class ScrollTop implements FluxStandardAction<number> {
  type = path + Types.scrollTop
  constructor(public payload: number) {}
}

export class Filter implements FluxStandardAction<string> {
  type = path + Types.filter
  constructor(public payload: string) {}
}
